export const AndroidIcon = () => {
  const fill = "#A4C639";
  return (
    <svg
      width="25"
      height="29"
      viewBox="0 0 25 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5003 16.5553C16.542 16.5553 19.8184 13.5309 19.8184 9.80013C19.8184 6.06933 16.542 3.04492 12.5003 3.04492C8.45857 3.04492 5.18213 6.06933 5.18213 9.80013C5.18213 13.5309 8.45857 16.5553 12.5003 16.5553Z"
        fill={fill}
        stroke="white"
        stroke-width="1.15804"
      />
      <path
        d="M18.0492 8.11133H6.95135C5.97424 8.11133 5.18213 8.90344 5.18213 9.88055V20.9784C5.18213 21.9555 5.97424 22.7476 6.95135 22.7476H18.0492C19.0263 22.7476 19.8184 21.9555 19.8184 20.9784V9.88055C19.8184 8.90344 19.0263 8.11133 18.0492 8.11133Z"
        fill={fill}
        stroke="white"
        stroke-width="1.15804"
      />
      <path
        d="M7.50165 1.96403C7.36169 1.71153 7.45292 1.39338 7.70541 1.25342C7.95791 1.11346 8.27606 1.20469 8.41602 1.45719L11.2621 6.59172C11.4021 6.84422 11.3109 7.16237 11.0584 7.30233C10.8059 7.44229 10.4877 7.35106 10.3478 7.09857L7.50165 1.96403Z"
        fill={fill}
        stroke="white"
        stroke-width="0.579018"
      />
      <path
        d="M20.1399 11.7304C20.1399 10.6644 21.004 9.80029 22.0699 9.80029C23.1359 9.80029 24 10.6644 24 11.7304V18.566C24 19.6319 23.1359 20.496 22.0699 20.496C21.004 20.496 20.1399 19.6319 20.1399 18.566V11.7304Z"
        fill={fill}
        stroke="white"
        stroke-width="0.579018"
      />
      <path
        d="M13.3044 19.5311C13.3044 18.4652 14.1685 17.6011 15.2345 17.6011C16.3004 17.6011 17.1646 18.4652 17.1646 19.5311V26.3668C17.1646 27.4327 16.3004 28.2968 15.2345 28.2968C14.1685 28.2968 13.3044 27.4327 13.3044 26.3668V19.5311Z"
        fill={fill}
        stroke="white"
        stroke-width="0.579018"
      />
      <path
        d="M17.4988 1.96403C17.6388 1.71153 17.5476 1.39338 17.2951 1.25342C17.0426 1.11346 16.7244 1.20469 16.5845 1.45719L13.7383 6.59172C13.5984 6.84422 13.6896 7.16237 13.9421 7.30233C14.1946 7.44229 14.5128 7.35106 14.6527 7.09857L17.4988 1.96403Z"
        fill={fill}
        stroke="white"
        stroke-width="0.579018"
      />
      <path
        d="M4.86012 11.7304C4.86012 10.6644 3.996 9.80029 2.93006 9.80029C1.86412 9.80029 1 10.6644 1 11.7304V18.566C1 19.6319 1.86412 20.496 2.93006 20.496C3.996 20.496 4.86012 19.6319 4.86012 18.566V11.7304Z"
        fill={fill}
        stroke="white"
        stroke-width="0.579018"
      />
      <path
        d="M11.6956 19.5311C11.6956 18.4652 10.8315 17.6011 9.76551 17.6011C8.69957 17.6011 7.83545 18.4652 7.83545 19.5311V26.3668C7.83545 27.4327 8.69957 28.2968 9.76551 28.2968C10.8315 28.2968 11.6956 27.4327 11.6956 26.3668V19.5311Z"
        fill={fill}
        stroke="white"
        stroke-width="0.579018"
      />
      <path
        d="M12.5003 16.5553C16.542 16.5553 19.8184 13.5309 19.8184 9.80013C19.8184 6.06933 16.542 3.04492 12.5003 3.04492C8.45857 3.04492 5.18213 6.06933 5.18213 9.80013C5.18213 13.5309 8.45857 16.5553 12.5003 16.5553Z"
        fill={fill}
      />
      <path
        d="M18.0492 8.11133H6.95135C5.97424 8.11133 5.18213 8.90344 5.18213 9.88055V20.9784C5.18213 21.9555 5.97424 22.7476 6.95135 22.7476H18.0492C19.0263 22.7476 19.8184 21.9555 19.8184 20.9784V9.88055C19.8184 8.90344 19.0263 8.11133 18.0492 8.11133Z"
        fill={fill}
      />
      <path d="M4.86035 10.0815H20.14H4.86035Z" fill="white" />
      <path d="M4.86035 10.0815H20.14" stroke="white" stroke-width="0.579018" />
      <path
        d="M9.12246 6.82451C9.30011 6.82451 9.44413 6.68049 9.44413 6.50283C9.44413 6.32517 9.30011 6.18115 9.12246 6.18115C8.9448 6.18115 8.80078 6.32517 8.80078 6.50283C8.80078 6.68049 8.9448 6.82451 9.12246 6.82451Z"
        fill="white"
        stroke="white"
        stroke-width="0.579018"
      />
      <path
        d="M15.8778 6.82451C16.0555 6.82451 16.1995 6.68049 16.1995 6.50283C16.1995 6.32517 16.0555 6.18115 15.8778 6.18115C15.7002 6.18115 15.5562 6.32517 15.5562 6.50283C15.5562 6.68049 15.7002 6.82451 15.8778 6.82451Z"
        fill="white"
        stroke="white"
        stroke-width="0.579018"
      />
    </svg>
  );
};
